import { render, staticRenderFns } from "./CheckoutCardConfirm.vue?vue&type=template&id=b6d8a4f0&"
import script from "./CheckoutCardConfirm.vue?vue&type=script&lang=js&"
export * from "./CheckoutCardConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports